import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { HomePanel } from '@/components/HomePanel';
import { ChatWindow } from '@/components/ChatWindow';
import { authService } from './auth-service';
function App() {
    const [selectedCharacter, setSelectedCharacter] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const unsubscribe = authService.onAuthStateChanged((user) => {
            if (user) {
                setIsAuthenticated(true);
            }
            else {
                window.location.href = '/login.html';
            }
            setIsLoading(false);
        });
        return () => unsubscribe();
    }, []);
    const handleSignOut = async () => {
        await authService.signOut();
        window.location.href = '/login.html';
    };
    if (isLoading) {
        return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-background", children: _jsx("div", { className: "animate-pulse text-muted-foreground", children: "Loading..." }) }));
    }
    if (!isAuthenticated) {
        return null;
    }
    return (_jsxs("div", { className: "relative", children: [_jsx("button", { onClick: handleSignOut, className: "fixed top-4 right-4 z-50 px-4 py-2 bg-destructive text-destructive-foreground rounded-md text-sm font-medium hover:bg-destructive/90 transition-colors", children: "Sign Out" }), selectedCharacter ? (_jsx(ChatWindow, { character: selectedCharacter, onBack: () => setSelectedCharacter(null) })) : (_jsx(HomePanel, { onSelectCharacter: setSelectedCharacter }))] }));
}
export default App;
